import { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Row, Col, Card, Label, CardBody, CardHeader, FormGroup } from 'reactstrap';
import Select from 'react-select';
import { Formik, Form, Field, FieldArray, FormikHelpers, ErrorMessage } from 'formik';
import { Plus, X } from 'react-feather';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';

import Swal from 'sweetalert2';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../Service/crypto';
import webservice from '../../../Service/webservice';
import * as Yup from 'yup';
import api from '../../../api';

const Editinsurance: React.FC = () => {
  const [formSubmit, setFormSubmit] = useState(false);
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    Payername: '',
    PayerID: '',
    PortalLink: '',
    SoftwareName: false,
    LogoUrl: '',
  });
  const [id, setId] = useState<string>(''); // State to hold the id
  const [refId, setRefId] = useState('');
  const [logoFile, setLogoFile] = useState<File | null>(null);

  const Username = localStorage.getItem('UserName') || '';

  const updatedata = async (data: any, id: string) => {
    const key = await keyPromise
    // const Data = {data,id}
    const EncParams = await AesEncrypt(key, { data, id });
    
    const res = await api.fetch('api/Insurance/edit', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    });
    const encryptedData = await res.json();
    const decryptedData = await AesDecrypt(key, encryptedData);

    return decryptedData;
  };

  const handleSubmit = async (data: any, { setSubmitting }: FormikHelpers<any>) => {
    if (formSubmit) {
      return;
    }
    const key = await keyPromise
    setFormSubmit(true);

    let updatedFields: any[] = [];

    for (const key in data) {
      if (initialValues && initialValues[key as keyof typeof initialValues] !== data[key as keyof typeof initialValues]) {
        const beforeValue = initialValues[key as keyof typeof initialValues];
        const afterValue = data[key as keyof typeof initialValues];

        if (beforeValue !== null && afterValue !== null) {
          updatedFields.push({
            field: key,
            before: beforeValue,
            after: afterValue,
          });
        }
      }
    }

    let finalData = { ...data };

    if (logoFile) {
      const formData = new FormData();
      formData.append('file', logoFile);
      
      try {
        const logoResponse = await api.fetch('api/Insurance/uploadLogo', {
          method: 'POST',
          body: formData,
        });
        const logoEncryptedData = await logoResponse.json();
        const logoDecryptedData = await AesDecrypt(key, logoEncryptedData);
        const logoResult = typeof logoDecryptedData === 'string' ? JSON.parse(logoDecryptedData) : logoDecryptedData;
        if (logoResult.success) {
          finalData.LogoUrl = logoResult.LogoUrl;
          updatedFields.push({
            field: 'LogoUrl',
            before: initialValues.LogoUrl,
            after: logoResult.LogoUrl,
          });
        } else {
          Swal.fire({
            title: 'Upload Error',
            icon: 'error',
            text: 'Failed to upload logo: ' + (logoResult.error || logoResult.message || 'Unknown error'),
          });
          setFormSubmit(false);
          setSubmitting(false);
          return;
        }
      } catch (e) {
         console.error("Exception during upload: ", e);
      }
    }

   // Transform Activestatus to send only the value
    const response = await updatedata(finalData, id);
    const decryptedResponse = response;

    if (decryptedResponse.success) {
      await updateAuditlog({ action: 'update', data: updatedFields, refId, Username });

      Swal.fire({
        title: 'Payer Mapping Management',
        icon: 'success',
        text: 'Payer Mapping Update Successfully!',
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      });
      navigate(`/insurance`);
    } else {
      Swal.fire({
        title: 'Payer Mapping Management',
        icon: 'error',
        text: 'Failed to update Payer Mapping!',
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'btn btn-danger',
        },
      });
    }
    setFormSubmit(false);
    setSubmitting(false);
  };

  const updateAuditlog = async (data: any) => {
    const key = await keyPromise
    data.Userid = localStorage.id;
    data.ParentUserId = localStorage.ParentUserId;
    const EncParams = await AesEncrypt(key,data);

    const response = await api.fetch('api/Insurance/editaudit', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    });
    return await response.json();
  };

  const getInsuranceData = async (id: string) => {
    const key = await keyPromise
    const EncParams = await AesEncrypt(key,id);
    const response = await api.fetch('api/Insurance/getinsurancedata', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());
    const TempData = await AesDecrypt(key,response);
    
    return TempData;
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = localStorage.getItem('InsuranceEdit');
      if (data != null) {
        const res = await getInsuranceData(data);
        if (res.length > 0) {
          setId(res[0].id);
          setRefId(res[0].RefId); // Set the id state
          setInitialValues({
            Payername: res[0].Payername || '',
            PayerID: res[0].PayerID || '',
            PortalLink: res[0].PortalLink || '',
            SoftwareName: res[0].SoftwareName === 1 || res[0].SoftwareName === true ? true : false,
            LogoUrl: res[0].LogoUrl || '',
          });
        }
      }
    };

    fetchData();
  }, []);

  const handleNumbers = (event: any) => {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
  }
  const validationSchema = Yup.object().shape({
    PayerID: Yup.string().required('Payer ID is required'),
    Payername: Yup.string().required('Payer Name is required'),
    // Email: Yup.string().email('Invalid email address').required('Email is required'),
    
  });
  return (
    <>
      <Breadcrumbs mainTitle='Insurance  Management' parent='Insurance  Management' title='Insurance  Management' to='/insurance' />
      <Fragment>
        <Card>
          <CardHeader style={{ backgroundColor: '#B4B4B3' }}>
            <h3>Edit Payer</h3>
          </CardHeader>
          <CardBody className='py-2 my-25'>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values, actions) => {
                handleSubmit(values, actions);
              }}
            >
              {({ values }) => (
                <Form className={`needs-validation custom-input ${formSubmit ? 'was-validated' : ''}`} noValidate>
                  <Row className="g-3">
                    <Col md={4} xs={12}>
                    <Label>Payer ID<span style={{ color: 'red' }}>*</span></Label>
                      <Field name="PayerID" type="text" className="form-control" placeholder="" required />
                      <ErrorMessage name="PayerID" component="span" className="text-danger" />
                    </Col>
                    <Col md={4} xs={12}>
                      <Label>Payer Name<span style={{ color: 'red' }}>*</span></Label>
                      <Field name="Payername" type="text" className="form-control" placeholder="" required />
                      <ErrorMessage name="Payername" component="span" className="text-danger" />
                    </Col>
                    <Col md={4} xs={12}>
                      <Label>Portal Link</Label>
                      <Field name="PortalLink" as="textarea" className="form-control" placeholder="" rows={3} />
                      <ErrorMessage name="PortalLink" component="span" className="text-danger" />
                    </Col>
                    <Col md={4} xs={12}>
                      <FormGroup>
                        <Label check>Software Name Required</Label>
                        <div className="form-check form-switch form-check-success" style={{ marginTop: '8px' }}>
                          <Field name="SoftwareName">
                            {({ field, form }: any) => (
                              <input
                                {...field}
                                type="checkbox"
                                className="form-check-input"
                                role="switch"
                                id="softwareNameEditSwitch"
                                checked={field.value}
                                onChange={(e) => form.setFieldValue(field.name, e.target.checked)}
                              />
                            )}
                          </Field>
                          <Label check for="softwareNameEditSwitch">{values.SoftwareName ? 'Enabled' : 'Disabled'}</Label>
                        </div>
                      </FormGroup>
                    </Col>
                    <Col md={4} xs={12}>
                      <Label>Payer Logo</Label>
                      {initialValues.LogoUrl && (
                        <div className="mb-2">
                          <img src={initialValues.LogoUrl} alt="Logo" style={{ maxHeight: '50px', maxWidth: '100px' }} />
                        </div>
                      )}
                      <input 
                        type="file" 
                        accept="image/*" 
                        className="form-control" 
                        onChange={(e) => {
                          if (e.target.files && e.target.files.length > 0) {
                            setLogoFile(e.target.files[0]);
                          }
                        }} 
                      />
                    </Col>
                    <Col>
                      <div className="text-end" style={{ marginTop: "100px" }}>
                        <button type="submit" className="btn btn-success me-3">Submit</button>
                        <Link to='/insurance'>
                          <button type="button" className="btn btn-danger">Cancel</button>
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </CardBody>
        </Card>
      </Fragment>
    </>
  );
};

export default Editinsurance;
